import React from 'react'

const FAQ = () => {
    return (
        <div className='faq container section-padding-y  w-80'>
            <div className='text-center mb-5'>
                <h1 style={{fontWeight:600}}>Frequently asked questions</h1>
                <p>Too confused? No worries, we got you.</p>
            </div>
            
            
            <div className='web-faq-card'>
                <h4>I’ve set up everything but my page isn’t working or I'm not able to see the pages?</h4>
                <p>This happens when we don't have access properly, make sure the database lies in the same workspace you've logged with and you've shared the page with our integration.</p>
            </div>
            <div className='web-faq-card'>
                <h4>Some elements on my notion page are not showing up on my notion diary</h4>
                <p>Notion API is still in BETA and it doesn’t support some blocks yet. For now, it supports headings, inline styling, paragraphs, lists, quotes and images. We’re working on keeping our application updated with Notion API.</p>
            </div>
            <div className='web-faq-card'>
                <h4>I didn’t get a single thing 🙂</h4>
                <p>No worries, I have a Loom video for the same. <a href='https://www.loom.com/share/697a1c85b2b74979aacca1d53c066646?sharedAppSource=personal_library' target="_blank" rel="noreferrer">Here</a></p>
            </div>
        </div>
    )
}

export default FAQ
